var dataRspackPrefix = "platinum:";

function getDataRspackId(identifier) {
	return dataRspackPrefix + identifier;
}

function applyStyle(styleElement, css) {
	styleElement.textContent = css;
}

function removeStyleElement(styleElement) {
	if (styleElement.parentNode) {
		styleElement.parentNode.removeChild(styleElement);
	}
}

function findStyleElement(identifier) {
	var elements = document.getElementsByTagName("style");
	for (var i = 0; i < elements.length; i++) {
		var el = elements[i];
		if (el.getAttribute("data-rspack") == getDataRspackId(identifier)) {
			return el;
		}
	}
	return null;
}

function insertStyleElement(key) {
	var style = document.createElement("style");
if (__webpack_require__.nc) {
  style.setAttribute("nonce", __webpack_require__.nc);
}
style.setAttribute("data-rspack", getDataRspackId(key));
	document.head.appendChild(style);
	return style;
}

__webpack_require__.is = (identifier, css) => {
	var element = findStyleElement(identifier);
	if (element) {
		applyStyle(element, css);
	} else {
		var element = insertStyleElement(identifier);
		applyStyle(element, css);
	}
};

__webpack_require__.is.removeModules = (removedModules) => {
	if (!removedModules) return;
	var identifiers = Array.isArray(removedModules) ? removedModules : [removedModules];
	for (var i = 0; i < identifiers.length; i++) {
		var identifier = identifiers[i];
		var element = findStyleElement(identifier);
		if (element) {
			removeStyleElement(element);
		}
	}
};

// no css inject style HMR download handler

